import { Icon } from '@mui/material';
import styled from 'styled-components';

export const IconDrawer = styled(Icon)`
    margin-top: 5px;
    font-size: 26px !important;
    cursor: pointer;
`;